/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const XenonLedLights = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 27 18" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M26.6 3.92A2.24 2.24 0 0 1 24.22 6h-5a19 19 0 0 0-.33-2.07l7.71-.01zM19.33 7.41h7.27a2.25 2.25 0 0 1-2.38 2.07h-4.89v-1c0-.31.02-.73 0-1.07zM26.6 10.89A2.25 2.25 0 0 1 24.22 13h-5.33a19.22 19.22 0 0 0 .33-2.08l7.38-.03zM18.51 14.38h8.09a2.25 2.25 0 0 1-2.38 2.07h-6.57c.11-.21.22-.43.33-.67.19-.44.37-.91.53-1.4zM17.65.44h9a2.25 2.25 0 0 1-2.38 2.07h-5.76a14.14 14.14 0 0 0-.51-1.4c-.13-.24-.24-.46-.35-.67zM12.83 0C6.77 0 0 4 0 8.94c0 4.94 6.8 9 12.86 9S18.88 0 12.83 0zM9.22 12.13h-.74a.18.18 0 0 1-.16-.13L6.83 9.6 5.32 12a.22.22 0 0 1-.16.09h-.74c-.17 0-.25-.14-.17-.27l2-3.16-1.9-3a.18.18 0 0 1 .16-.27h.79a.2.2 0 0 1 .16.09l1.33 2.28 1.39-2.23a.18.18 0 0 1 .15-.09h.82a.17.17 0 0 1 .16.27l-1.89 3 2 3.16a.17.17 0 0 1-.2.26zm5.5-.19c0 .1-.08.18-.18.18h-3.82a.18.18 0 0 1-.18-.19V5.62c0-.1.08-.18.18-.18h3.83c.1 0 .18.08.18.18v.53a.19.19 0 0 1-.18.19h-3v1.95h2.55a.19.19 0 0 1 .18.19V9c0 .1-.08.18-.18.18h-2.58v2.06h3a.19.19 0 0 1 .18.19l.02.51z" /></g>
      </g>
    </svg>
  </span>
);

XenonLedLights.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

XenonLedLights.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default XenonLedLights;
